var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"vf-select",staticStyle:{"margin":"0 0 1rem 0"},attrs:{"clearable":true,"options":_vm.filter.options,"multiple":false,"placeholder":_vm.filter.label,"label":_vm.labelKey,"value":_vm.value},on:{"input":function($event){return _vm.$emit('set-filter', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }